import { useSearchParams } from 'react-router-dom';

import { useEnterpriseSsoRequiredNotice, useOnboardingRedirect, useWakeBackend } from '@neo.tax/onboarding/hooks';
import { TestimonialMemo, StyledSplitScreen, EnterpriseSsoFormHeader } from '@neo.tax/onboarding/organisms';
import { Loader, Path, env, getInvitationLoginPath, getPath } from '@neo.tax/shared';

import { useSsoInvitation } from './hooks/useSsoInvitation';
import { EnterpriseSsoForm } from './organisms';

export const EnterpriseSso = (): React.ReactElement => {
  useWakeBackend();

  // Instances configured for enterprise SSO only redirect past the sign-in form, so this page is where their
  // users land after the backend clears a session it will not admit.
  useEnterpriseSsoRequiredNotice();
  const ssoInvitation = useSsoInvitation();
  const [searchParams] = useSearchParams();

  return (
    <Loader useRedirect={useOnboardingRedirect}>
      <StyledSplitScreen
        leftSide={
          <EnterpriseSsoFormHeader
            pageChangeText="go back to"
            pageChangeLinkText="Login"
            pageChangeTo={
              ssoInvitation
                ? getInvitationLoginPath({
                    token: ssoInvitation.inviteToken,
                    prefillEmail: searchParams.get('prefillEmail'),
                    ssoProviderId: ssoInvitation.ssoProviderId,
                  })
                : getPath({ path: Path.LOGIN })
            }
            subtitleIsActive={env.REACT_APP_ENTERPRISE_SSO_LOGIN_ONLY === false}
            title={ssoInvitation ? "Sign in with your organization's SSO" : 'Enter your Provider ID'}
            form={<EnterpriseSsoForm />}
          />
        }
        rightSide={<TestimonialMemo />}
      />
    </Loader>
  );
};
